// extracted by mini-css-extract-plugin
module.exports = {"card":"_1410bfd27b--card--m4p1W","card-inner":"_1410bfd27b--card-inner--_ocrR","title-text":"_1410bfd27b--title-text--CIKuD","subtitle-text":"_1410bfd27b--subtitle-text--yklti"};